import { About } from './sections/About';
import { Cta } from './sections/Cta';
import { Footer } from './sections/Footer';
import { Hero } from './sections/Hero';
import { IncomeStreams } from './sections/IncomeStreams';
import { Nav } from './sections/Nav';
import { Package } from './sections/Package';
import { Roadmap } from './sections/Roadmap';
import { Ticker } from './sections/Ticker';

export function App() {
  return (
    <>
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <About />
        <IncomeStreams />
        <Package />
        <Roadmap />
        <Cta />
      </main>
      <Footer />
    </>
  );
}
